import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "围观现场" },
  { to: "/events", label: "瓜田广场" },
  { to: "/comments", label: "神评榜" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) {
      navigate("/events");
      return;
    }
    navigate(`/events?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/90 backdrop-blur-md"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="flex h-16 md:h-[72px] w-full items-center gap-4 px-4 md:px-8">
          <NavLink to="/" className="flex shrink-0 items-center gap-2 pointer-events-auto">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-fire-line text-xl text-background-50"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                瓜田热评
              </span>
              <span className="mt-0.5 text-[10px] font-medium tracking-[0.22em] text-foreground-500">
                GUATIAN REVIEWS
              </span>
            </span>
          </NavLink>

          <nav className="ml-4 hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="ml-auto hidden items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3.5 py-2 transition-colors focus-within:border-primary-300 focus-within:bg-background-50 md:flex"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索事件或关键词"
              className="w-36 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 lg:w-48"
              aria-label="搜索事件"
            />
          </form>

          <NavLink
            to="/about"
            className="ml-auto hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex md:ml-3"
          >
            <i className="ri-group-line mr-1.5 text-base"></i>
            加入吃瓜群
          </NavLink>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-100 text-foreground-900 lg:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-b border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <form onSubmit={handleSearch} className="mb-3">
            <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3.5 py-2.5">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索事件或关键词"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                aria-label="搜索事件"
              />
            </div>
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-3 text-sm font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}